<template>
  <div id="app">
    <div class="top_main">
      <video :src="topvideo" autoplay muted loop class="bg"></video>
      <img src="../assets/logo.png" alt class="logo" />
      <div class="fun_dom">
        <div class="qr_">
          <img src="../assets/pc/qr.png" alt class="qr" />
        </div>
        <div class="download_">
          <a :href="urlList.ios_url" target="_blank">
            <img src="../assets/pc/app.png" alt class="app" />
          </a>
          <a :href="urlList.android_url" target="_blank">
            <img src="../assets/pc/google.png" alt class="google" />
          </a>
          <a :href="urlList.apk_url" target="_blank">
            <img src="../assets/pc/mycard.png" alt class="mycard" />
          </a>
        </div>
      </div>
      <img src="../assets/pc/godown.png" alt class="godown" />
    </div>
    <div class="pic_main pcMain" ref="pic_big">
      <img src="../assets/pc/gamepic/bg.jpg" alt class="bg" />
      <div class="title">
        <img src="../assets/pc/gamepic/title.png" alt class="title" />
      </div>
      <transition
        enter-active-class="animate__animated animate__fadeInUp"
        leave-active-class="animate__animated animate__fadeOutUp"
      >
        <div class="pic_dom" v-if="pic_show">
          <div class="pic_big">
            <transition enter-active-class="animate__animated animate__fadeIn">
              <div class="pic_big_" v-if="pic==1">
                <img src="../assets/pc/gamepic/campsBig.png" alt />
              </div>
            </transition>
            <transition enter-active-class="animate__animated animate__fadeIn">
              <div class="pic_big_" v-if="pic==2">
                <img src="../assets/pc/gamepic/daynightBig.png" alt />
              </div>
            </transition>
            <transition enter-active-class="animate__animated animate__fadeIn">
              <div class="pic_big_" v-if="pic==3">
                <img src="../assets/pc/gamepic/groupBig.png" alt />
              </div>
            </transition>
            <transition enter-active-class="animate__animated animate__fadeIn">
              <div class="pic_big_" v-if="pic==4">
                <img src="../assets/pc/gamepic/militaryBig.png" alt />
              </div>
            </transition>
            <transition enter-active-class="animate__animated animate__fadeIn">
              <div class="pic_big_" v-if="pic==5">
                <img src="../assets/pc/gamepic/manorBig.png" alt />
              </div>
            </transition>
          </div>
          <div class="pic_small">
            <div class="pic_small_" :class="pic==1?'active':''" @mouseover="showBig(1)">
              <img src="../assets/pc/gamepic/camps.png" alt />
            </div>
            <div class="pic_small_" :class="pic==2?'active':''" @mouseover="showBig(2)">
              <img src="../assets/pc/gamepic/daynight.png" alt />
            </div>
            <div class="pic_small_" :class="pic==3?'active':''" @mouseover="showBig(3)">
              <img src="../assets/pc/gamepic/group.png" alt />
            </div>
            <div class="pic_small_" :class="pic==4?'active':''" @mouseover="showBig(4)">
              <img src="../assets/pc/gamepic/military.png" alt />
            </div>
            <div class="pic_small_" :class="pic==5?'active':''" @mouseover="showBig(5)">
              <img src="../assets/pc/gamepic/manor.png" alt />
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="video_main" ref="video_dialog">
      <img src="../assets/pc/gamevideo/bg.jpg" alt class="bg" />
      <img src="../assets/pc/gamevideo/title.png" alt class="title" />
      <transition-group
        enter-active-class="animate__animated animate__fadeInUp"
        leave-active-class="animate__animated animate__fadeOutUp"
      >
        <div class="video_dom" v-if="vd_show" :key="1">
          <img src="../assets/pc/gamevideo/frame.png" alt class="iframe" />
          <img
            src="../assets/pc/gamevideo/play.png"
            alt
            class="play"
            :class="play_btn==1?'offplay':''"
            @click="play()"
          />
          <div class="video_" v-for="(item,index) in video_list" :key="item.id">
            <video
              :src="item.url"
              :poster="item.imgUrl"
              controls
              id="videos"
              v-if="video_in==index"
            ></video>
          </div>
        </div>
        <img src="../assets/pc/gamevideo/listbg.png" alt class="listbg" v-if="vd_show" :key="2" />
        <div class="video_list" v-if="vd_show" :key="3">
          <div class="prev" :class="v_control==0?'no_click':''" @click="prev">
            <img src="../assets/pc/gamevideo/left.png" alt />
          </div>
          <div class="pic_">
            <div
              class="pic_list"
              id="picL"
              ref="pic_list"
              :style="{transform:`translateX(${transfromX}px)`}"
            >
              <div
                class="pic_item"
                v-for="(item,index) in video_list"
                :key="index"
                @click="changeVideo(index)"
              >
                <img :class="item.id==video_in?'active':''" :src="item.imgUrl" alt />
                <img
                  src="../assets/pc/gamevideo/play.png"
                  alt
                  class="item_play"
                  :class="item.id==video_in?'actives':''"
                />
                <p>{{item.name}}</p>
              </div>
            </div>
          </div>
          <div class="next" :class="v_control==1?'no_click':''" @click="next">
            <img src="../assets/pc/gamevideo/right.png" alt />
          </div>
        </div>
      </transition-group>
    </div>
    <div class="fb_main" ref="fb_dialog">
      <img src="../assets/pc/gamefb/bg.jpg" alt class="bg" />
      <img src="../assets/pc/gamefb/title.png" alt class="title" />
      <transition-group
        enter-active-class="animate__animated animate__fadeInUp"
        leave-active-class="animate__animated animate__fadeOutUp"
      >
        <div class="fb_dialog_dom" :key="1" v-show="fb_show">
          <!-- <iframe
            src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2F106821754191721%2Fposts%2F132781414929088%2F&width=750&show_text=true&height=183&appId"
            width="100%"
            height="100%"
            style="border:none;overflow:hidden"
            scrolling="no"
            frameborder="0"
            allowtransparency="true"
            allow="encrypted-media"
          ></iframe>-->
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F3KD.MFG%2F&tabs=timeline&width=500&height=600&small_header=false&hide_cover=false&show_facepile=true&appId"
            width="100%"
            height="100%"
            style="border:none;overflow:auto;"
            scrolling="1"
            frameborder="0"
            allowtransparency="true"
            allow="encrypted-media"
          ></iframe>
        </div>

        <img
          src="../assets/pc/gamefb/fream.png"
          alt
          class="fb_dialog_dom_frame"
          :key="2"
          v-if="fb_show"
        />
      </transition-group>
      <div class="footer_">
        <img src="../assets/pc/footer.png" alt class="footer_bg" />
        <ul>
          <a href="https://www.gamemorefun.com/front/introduce" target="_blank">
            <li></li>
          </a>
          <a href="https://www.gamemorefun.com/front/relation" target="_blank">
            <li></li>
          </a>
          <a href="https://www.gamemorefun.com/front/clause" target="_blank">
            <li></li>
          </a>
          <a href="https://www.gamemorefun.com/front/policy" target="_blank">
            <li></li>
          </a>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import topvideo from "../../public/head.mp4";
import video1 from "../../public/video/0.mp4";
import video2 from "../../public/video/1.mp4";
import video3 from "../../public/video/2.mp4";
import video4 from "../../public/video/3.mp4";
import video5 from "../../public/video/4.mp4";
import video6 from "../../public/video/5.mp4";
import video7 from "../../public/video/6.mp4";
import video8 from "../../public/video/7.mp4";
import video9 from "../../public/video/8.mp4";
import img5 from "../../public/video/5.png";
import img6 from "../../public/video/6.png";
import img7 from "../../public/video/7.png";
import img8 from "../../public/video/8.png";
export default {
  name: "App",
  components: {},
  data: function () {
    return {
      pic: 1,
      pic_show: false,
      fb_show: false,
      vd_show: false,
      video_in: 0,
      v_control: 0,
      transfromX: 0,
      listInArray: [],
      play_in: 0,
      play_btn: 0,
      topvideo: topvideo,
      tabpages: { pages: 100, pageNum: 1 },
      urlList:{ios_url:'',fb_fans_url:'',apk_url:'',android_url:''},
      video_list: [
        {
          id: 0,
          url: video6,
          name: "許紹雄&郭峰 梟雄對弈",
          imgUrl: img5,
        },
        {
          id: 1,
          url: video7,
          name: "許紹雄：我要改朝換代",
          imgUrl: img6,
        },
        {
          id: 2,
          url: video8,
          name: "姜皓文：我的軍團有內奸",
          imgUrl: img7,
        },
        {
          id: 3,
          url: video9,
          name: "姜皓文：我要的是整個中原",
          imgUrl: img8,
        },
        {
          id: 4,
          url: video1,
          name: "《新三国 漢室復興》-攻城战",
          imgUrl: "https://3kd.gamemorefun.net/video/0.png",
        },
        {
          id: 5,
          url: video2,
          name: "《新三國 漢室復興》CG",
          imgUrl: "https://3kd.gamemorefun.net/video/1.png",
        },
        {
          id: 6,
          url: video3,
          name: "《新三國 漢室復興》-風雲篇1",
          imgUrl: "https://3kd.gamemorefun.net/video/2.png",
        },
        {
          id: 7,
          url: video4,
          name: "《新三國 漢室復興》玩法內容",
          imgUrl: "https://3kd.gamemorefun.net/video/3.png",
        },
        {
          id: 8,
          url: video5,
          name: "《新三國 漢室復興》-演武戰",
          imgUrl: "https://3kd.gamemorefun.net/video/4.png",
        },
      ],
    };
  },
  mounted: function () {
    let that = this;
    let throttleScroll = this.throttle(that.init_scroll, 300);
    window.addEventListener("scroll", function () {
      throttleScroll();
    });
    window.fbAsyncInit = function () {
      FB.init({
        appId: "1407439736082162",
        cookie: true,
        xfbml: true, // 解析此页面上的社交插件
        version: "v2.8", // 使用图形api 2.8版本
      });
    };
    if (this.video_list.length < 5) {
      this.v_conturl = 0;
    }
    this.listInArray = [0, 3];
    this.$axios.post('https://api.hermesgames.com.tw/front/game/url', {appid:'bmccfg',timestamp:+new Date()}).then(response => {
        if(response.data.status==2000){
            that.urlList = response.data.data
        }
    })

  },
  watch: {
    vd_show(n, o) {
      if (n) {
        this.$nextTick(function () {
          this.init_video();
          this.$refs["pic_list"].style.width =
            this.video_list.length * 250 + "px";
          this.get_item();
        });
      }
    },
    video_in(n, o) {
      this.$nextTick(function () {
        this.init_video();
      });
      if (n == 0) {
        this.v_control = 0;
      } else if (n == this.video_list.length - 1) {
        this.v_control = 1;
      } else {
        this.v_control = 2;
      }
    },
  },
  methods: {
    changeVideo: function (e) {
      this.play_btn = 0;
      this.video_in = e;
    },
    prev: function () {
      if (this.video_in == 0) return; //无法左滑
      this.video_in -= 1;
      let listInArray = this.listInArray;
      let max = Math.max(...listInArray);
      let min = Math.min(...listInArray);
      if (this.video_in < min) {
        this.transfromX += this.get_item();
        this.listInArray = [];
        this.listInArray.push(this.video_in);
        this.listInArray.push(max - 1);
      }
      // let that = this
      // setTimeout(function(){
      //    that.init_video()
      // },500)
    },
    next: function () {
      if (this.video_in == this.video_list.length - 1) return;
      this.video_in += 1;
      let listInArray = this.listInArray;
      let max = Math.max(...listInArray);
      let min = Math.min(...listInArray);
      if (this.video_in > max) {
        this.transfromX = -(this.get_item() * (this.video_in - 3));
        this.listInArray = [];
        this.listInArray.push(min + 1);
        this.listInArray.push(this.video_in);
      }
      // let that = this

      // setTimeout(function(){
      //    that.init_video()
      // },500)
    },
    play: function () {
      let that = this;
      this.play_btn = 1;
      let dom = document.getElementById("videos");
      dom.play();
      this.init_video();
    },
    init_video: function () {
      let that = this;
      let dom = document.getElementById("videos");

      dom.addEventListener("pause", function () {
        that.play_btn = 0;
      });
      dom.addEventListener("play", function () {
        that.play_btn = 1;
      });
      dom.addEventListener("end", function () {
        that.play_btn = 0;
      });
    },
    get_item: function () {
      let dom = document.querySelector(".pic_item");
      let width, marginRight;
      if (window.getComputedStyle) {
        width = window.getComputedStyle(dom, null).width;
        marginRight = window.getComputedStyle(dom, null).marginRight;
      } else {
        width = dom.currentStyle.width;
        marginRight = dom.currentStyle.marginRight;
      }
      return (
        Number(width.substring(0, width.length - 2)) +
        Number(marginRight.substring(0, marginRight.length - 2))
      );
    },
    showBig: function (e) {
      this.pic = e;
    },
    init_scroll: function () {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      let vd_, fb_;
      let that = this;
      this.$nextTick(function () {
        vd_ = that.$refs["video_dialog"].offsetTop;
        fb_ = that.$refs["fb_dialog"].offsetTop;
        if (top > 100) {
          that.pic_show = true;
        }
        if (top + window.innerHeight - vd_ > 150) {
          that.vd_show = true;
        }
        if (top + window.innerHeight - fb_ > 150) {
          that.fb_show = true;
        }
      });
    },
  },
};
</script>

<style lang='scss'>
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  height: 100%;

  .top_main {
    width: 100%;
    position: relative;
    overflow-x: hidden;
    .bg {
      width: 100%;
      display: block;
    }
    .logo {
      position: absolute;
      width: 3.4rem;
      top: 0.3rem;
      left: 50%;
      margin-left: -8rem;
    }
    .fun_dom {
      width: 3rem;
      height: 1.5rem;
      position: absolute;
      top: 50%;
      margin-top: 1.5rem;
      left: 50%;
      margin-left: -1.5rem;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;
      align-items: center;
      .qr_ {
        width: 50%;
        height: 100%;
        img {
          display: block;
          width: 100%;
        }
      }
      .download_ {
        width: 1.35rem;
        a {
          display: block;
          line-height: 0.2rem;
        }
        .app,
        .google,
        .mycard {
          width: 1.35rem;
          display: block;
          margin-bottom: 0.04rem;
        }
      }
    }
    .godown {
      position: absolute;
      width: 0.37rem;
      top: 50%;
      margin-top: 3.8rem;
      left: 50%;
      margin-left: -0.2rem;
    }
  }
  .pic_main {
    width: 100%;
    position: relative;
    overflow: hidden;
    .bg {
      width: 100%;
      display: block;
    }
    .title {
      width: 19rem;
      position: absolute;
      top: 0;
      left: 0;
    }
    .pic_dom {
      width: 13.25rem;
      top: 50%;
      margin-top: -2.4rem;
      left: 50%;
      margin-left: -6.625rem;
      position: absolute;
      img {
        display: block;
      }
      .pic_big {
        width: 100%;
        margin-bottom: 0.5rem;
        height: 4.1rem;
        overflow: hidden;
        .pic_big_ {
          width: 100%;
        }
      }
      .pic_small {
        width: 116%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-around;
        margin-left: -8%;
        .pic_small_ {
          width: 2.6rem;
          height: 1.465rem;
          cursor: default;
          border: 3px solid rgba(0, 0, 0, 0);
          transition: 0.3s border linear;
        }
        .active {
          border: 3px solid #ba9e5a;
        }
      }
    }
    .small_dom {
      width: 13.25rem;
      top: 50%;
      margin-top: -3.5rem;
      left: 50%;
      margin-left: -6.625rem;
      position: absolute;
    }
  }
  .video_main {
    width: 100%;
    position: relative;
    overflow: hidden;
    .bg {
      width: 100%;
      display: block;
    }
    .title {
      width: 18rem;
      position: absolute;
      top: 0;
      right: 0;
    }
    .video_dom {
      width: 9.35rem;
      height: 5.34rem;
      position: absolute;
      top: 50%;
      margin-top: -3rem;
      left: 50%;
      margin-left: -4.67rem;
      overflow: hidden;

      .video_ {
        position: relative;
        z-index: 11;
        video {
          width: 9.1rem;
          height: 5.16rem;
          margin-top: 0.1rem;
          margin-left: 0.12rem;
        }
      }
      .iframe {
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        z-index: 10;
      }
      .play {
        width: 1rem;
        height: 1rem;
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
        left: 50%;
        margin-left: -0.5rem;
        cursor: pointer;
        z-index: 12;
        transition: top 0.3s ease-in;
      }
      .offplay {
        top: 10rem;
      }
    }
    .listbg {
      width: 100%;
      height: 2rem;
      position: absolute;
      bottom: 0.2rem;
      left: 0;
    }
    .video_list {
      width: 100%;
      height: 2rem;
      position: absolute;
      bottom: 0.2rem;
      left: 0;
      .prev {
        width: 0.58rem;
        height: 0.71rem;
        position: absolute;
        left: 50%;
        margin-left: -6rem;
        top: 0.6rem;
        cursor: pointer;
        img {
          display: block;
        }
      }
      .next {
        width: 0.58rem;
        height: 0.71rem;
        position: absolute;
        left: 50%;
        margin-left: 5.42rem;
        top: 0.6rem;
        cursor: pointer;
        img {
          display: block;
        }
      }
      .no_click {
        opacity: 0.4;
      }
      .pic_ {
        width: 9.5rem;
        height: 1.6rem;
        position: absolute;
        top: 0.3rem;
        left: 50%;
        margin-left: -4.7rem;
        overflow: hidden;
      }
      .pic_list {
        transition: all 0.4s ease;
        .pic_item {
          width: 2.1rem;
          float: left;
          margin-right: 0.3rem;
          cursor: pointer;
          position: relative;
          img {
            display: block;
            width: 100%;
            border: 2px solid rgba(0, 0, 0, 0);
            transition: all 0.3s ease-in;
          }

          .active {
            border: 2px solid #ba9e5a;
          }
          .actives {
          }
          .item_play {
            position: absolute;
            width: 0.6rem;
            height: 0.6rem;
            top: 50%;
            margin-top: -0.5rem;
            left: 50%;
            margin-left: -0.3rem;
          }
        }
        .pic_item:hover {
          img {
            opacity: 1;
          }
        }
        p {
          margin: 0.05rem 0 0;
          font-size: 0.14rem;
          color: #f7eaca;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .fb_main {
    width: 100%;
    position: relative;
    overflow-x: hidden;
    .bg {
      width: 100%;
      display: block;
    }
    .title {
      width: 17rem;
      position: absolute;
      top: 0;
      left: 0;
    }
    .fb_dialog_dom {
      width: 500px;
      height: 6.4rem;
      top: 2.3rem;
      left: 50%;
      margin-left: -250px;
      position: absolute;
      background-color: white;
      z-index: 3;
    }
    .fb_dialog_dom_frame {
      width: 528px;
      height: 6.6rem;
      top: 2.2rem;
      left: 50%;
      margin-left: -264px;
      position: absolute;
    }
  }
  .footer_ {
    position: absolute;
    bottom: 0; 
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
    ul {
      position: absolute;
      list-style: none;
      top: 3.9rem;
      left: 5.7rem;
      width: 6rem;
      margin: 0;
      padding: 0;
      a {
        display: block;
      }
      li {
        float: left;
        width: .8rem;
        height: 0.5rem;
      }
    }
  }
}
</style>
